var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"hide-profile":""}}),_vm._v(" "),_c('nuxt',{staticClass:"layout",attrs:{"id":"inner"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }